import { render, staticRenderFns } from "./AddModelPlugin.vue?vue&type=template&id=4182bed7&scoped=true"
import script from "./AddModelPlugin.vue?vue&type=script&lang=ts"
export * from "./AddModelPlugin.vue?vue&type=script&lang=ts"
import style0 from "./AddModelPlugin.vue?vue&type=style&index=0&id=4182bed7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182bed7",
  null
  
)

export default component.exports